import React from "react";
import { Button, Modal } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { saveUserAcceptTermsRequest } from "ducks/user";
import { setActiveDialog, logout } from "ducks/app";

const _ = require("lodash");

const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    return {
      user: state.app.userState
    };
  };
  return mapStateToProps;
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveUserAcceptTermsRequest,
      setActiveDialog,
      logout
    },
    dispatch
  );
class TermsConditionsModal extends React.Component {
  render() {
    const { account } = this.props;
    let html = account && account.attributes && account.attributes.userTerms;
    html = _.replace(html, new RegExp("<p><br></p>", "g"), "");
    return account &&
      account.attributes &&
      account.attributes.userTerms &&
      !this.props.user.attributes.acceptedTerms ? (
      <Modal
        title="Terms and Conditions"
        wrapClassName="vertical-center-modal"
        visible={this.props.show}
        width="60vw"
        okText="Save"
        footer={null}
        onClick={() => {
          this.props.setActiveDialog();
          this.props.logout();
        }}
      >
        <div
          style={{
            padding: "15px",
            maxHeight: "500px",
            overflowY: "scroll",
            overflowX: "none"
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: html
            }}
          />
        </div>
        <div className="d-flex flex-row my-3">
          <div>
            <Button
              type="primary"
              onClick={() => {
                this.props.saveUserAcceptTermsRequest();
                this.props.setActiveDialog();
              }}
            >
              I Agree
            </Button>
          </div>
          <div className="flex-fill text-right">
            <Button
              type="default"
              className="text-right"
              onClick={() => {
                this.props.logout();
                this.props.setActiveDialog();
              }}
            >
              Logout
            </Button>
          </div>
        </div>
      </Modal>
    ) : null;
  }
}

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(TermsConditionsModal);



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TermsConditions/index.js